export enum RoleType {
  CARE_COORDINATOR = 'Coordinator',
  CLINICIAN = 'Clinician',
  MSO_ADMIN = 'MSO Admin',
  ADMIN = 'Admin',
  CARE_MANAGER = 'Care Manager',
}
